import React, { PureComponent, forwardRef } from 'react';
import { playerContextFilter } from '@cassette/core';
import Icon from '@material-ui/core/Icon';
import classNames from 'classnames';

const ButtonWrapper = forwardRef(({ className, children, ...rest }, ref) => {
  return (
    <div
      ref={ref}
      className={classNames('cassette__media_button_wrapper d-flex justify-content-center', className)}
      style={{
        cursor: 'pointer'
      }}
      {...rest}
    >
      {children}
    </div>
  );
});

export class PlayPauseButton extends PureComponent {
  render() {
    const { paused, onTogglePause } = this.props;
    return (
      <ButtonWrapper onClick={onTogglePause}>
        <Icon style={{fontSize: 48}}>
          {paused ? 'play_circle_outline' : 'pause_circle_outline'}
        </Icon>
      </ButtonWrapper>
    );
  }
}

export default playerContextFilter(PlayPauseButton, [
  'paused',
  'awaitingResumeOnSeekComplete',
  'onTogglePause'
]);



// WEBPACK FOOTER //
// ./src/js/components/Mui/AudioButton.js